import { Skeleton, Divider } from "@mui/joy";
import styles from "./index.module.css";

/**
 * Skeleton that mirrors the real game card structure (header + stats + tags +
 * divider + 3 group rows). Height is governed by the parent cardSlot wrapper,
 * not by inline style — no brittle pixel values here.
 */
const SkeletonGameCard: React.FC = () => (
  <div className="card card-2-margin">
    {/* GameInfo header row */}
    <div className={styles.mainWrapper}>
      <Skeleton variant="rectangular" width={64} height={64} sx={{ borderRadius: '12px', flexShrink: 0 }} />
      <div className={styles.infoWrapper}>
        <Skeleton variant="text" width={160} />
        <Skeleton variant="text" width={100} />
        <Skeleton variant="text" width={120} />
      </div>
      <div className={styles.rightButton}>
        <Skeleton variant="rectangular" width={80} height={36} sx={{ borderRadius: '20px' }} />
      </div>
    </div>
    {/* Statistics row */}
    <div className={styles.statsRow}>
      <Skeleton variant="text" width={120} />
      <Skeleton variant="text" width={100} />
    </div>
    {/* Tags row */}
    <div className={styles.tagsRow}>
      <Skeleton variant="rectangular" width={72} height={24} sx={{ borderRadius: '12px' }} />
      <Skeleton variant="rectangular" width={60} height={24} sx={{ borderRadius: '12px' }} />
    </div>
    <Divider sx={{ my: 1 }} />
    {/* GroupsBlock label */}
    <Skeleton variant="text" width={120} sx={{ mb: 1 }} />
    {/* 3 group rows — API always returns popular_groups[:3] */}
    {Array.from({ length: 3 }).map((_, i) => (
      <div key={i} className={styles.groupRow}>
        <Skeleton variant="rectangular" width={50} height={50} sx={{ borderRadius: '10px', flexShrink: 0 }} />
        <div className={styles.groupRowText}>
          <Skeleton variant="text" width={140} />
          <Skeleton variant="text" width={80} />
        </div>
        <div className={styles.rightButton}>
          <Skeleton variant="rectangular" width={72} height={30} sx={{ borderRadius: '16px' }} />
        </div>
      </div>
    ))}
  </div>
);

const SkeletonCard: React.FC<{ length?: number; loading?: boolean }> = ({
  length = 3,
  loading = false,
}) => {
  if (!loading) return null;
  return (
    <>
      {Array.from({ length: length || 1 }).map((_, index) => (
        <SkeletonGameCard key={index} />
      ))}
    </>
  );
};
export default SkeletonCard;
